export default __webpack_public_path__ + "static/book4444-84fda5115d46a8c239c235ce1342157a.png";